import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/utils";

interface Props
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLParagraphElement>,
    HTMLParagraphElement
  > {
  children: ReactNode;
  className?: string;
}

export const TypographySM = ({ children, className, ...props }: Props) => {
  return (
    <p className={cn("text-sm ", className)} {...props}>
      {children}
    </p>
  );
};
